/**
 * The groups a connection's config form is laid out in. Mirrored by
 * `__fixtures__/conformance/config-groups.json`, which the bridge's Go release test reads.
 */
export const ConfigGroup = {
  INSTALLATION: 'installation',
  LOGIN: 'login',
  COMPANY: 'company',
  DATABASE: 'database',
  LOCALE: 'locale',
  DOCUMENT_TYPES: 'documentTypes',
  PAYMENT: 'payment',
  VAT_CODES: 'vatCodes',
  ADVANCED: 'advanced'
} as const;

export type ConfigGroup = (typeof ConfigGroup)[keyof typeof ConfigGroup];

/** Every group, in the order the form shows them. */
export const CONFIG_GROUP_ORDER = [
  ConfigGroup.INSTALLATION,
  ConfigGroup.LOGIN,
  ConfigGroup.COMPANY,
  ConfigGroup.DATABASE,
  ConfigGroup.LOCALE,
  ConfigGroup.DOCUMENT_TYPES,
  ConfigGroup.PAYMENT,
  ConfigGroup.VAT_CODES,
  ConfigGroup.ADVANCED
] as const satisfies readonly ConfigGroup[];

/** Groups shown as a codelist mapping table: one row per key, Tappeer value to target code. */
export const CONFIG_MAPPING_GROUPS = [
  ConfigGroup.DOCUMENT_TYPES,
  ConfigGroup.PAYMENT,
  ConfigGroup.VAT_CODES
] as const satisfies readonly ConfigGroup[];

export type ConfigMappingGroup = (typeof CONFIG_MAPPING_GROUPS)[number];

/** True when a group, possibly from stored or untrusted data, is a mapping group. */
export const isConfigMappingGroup = (group: unknown): group is ConfigMappingGroup =>
  CONFIG_MAPPING_GROUPS.some(mapping => mapping === group);
